export default __webpack_public_path__ + "static/media/6.df600a8b.png";